const initialState = {
	user: null,
	token: null,
	loginLoading: false,
	authErrors: null,
};

export default initialState;
